<template>
<div class="toolbar-group">
  <slot />
</div>
</template>

<script>
export default {
}
</script>
